export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Blade.6120c0ae.jpg";